import type {Context} from '../types';

// Filter out children IDs that are nowhere to be found in the tree
export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {nodeMap},
  } = context;
  const {children} = jsonNode;
  const foundChildrenIds: Array<any> = [];
  const missingChildrenIds: Array<any> = [];

  if (children && children.length) {
    children.forEach((childId) => {
      if (nodeMap.get(childId)) {
        foundChildrenIds.push(childId);
      } else {
        missingChildrenIds.push(childId);
      }
    });
  }

  return {
    needed: Boolean(missingChildrenIds.length),
    logData: {
      msg: 'childIds that reference missing nodes',
      meta: {
        nodeId: jsonNode._id,
        missingChildren: missingChildrenIds,
      },
    },
    apply: () => {
      jsonNode.children = foundChildrenIds;
    },
  };
};
